
import React from 'react';
import {
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface UserInfoFieldsProps {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  errors: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
  };
  setFormField: (field: string, value: any) => void;
}

const UserInfoFields: React.FC<UserInfoFieldsProps> = ({
  firstName,
  lastName,
  email,
  phone,
  errors,
  setFormField
}) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <FormItem>
            <FormLabel htmlFor="firstName">First Name*</FormLabel>
            <FormControl>
              <Input
                id="firstName"
                placeholder="John"
                value={firstName}
                onChange={(e) => setFormField('firstName', e.target.value)}
                className={errors.firstName ? "border-red-500" : ""}
              />
            </FormControl>
            {errors.firstName && <FormMessage>{errors.firstName}</FormMessage>}
          </FormItem>
        </div>
        
        <div>
          <FormItem>
            <FormLabel htmlFor="lastName">Last Name*</FormLabel>
            <FormControl>
              <Input
                id="lastName"
                placeholder="Doe"
                value={lastName}
                onChange={(e) => setFormField('lastName', e.target.value)}
                className={errors.lastName ? "border-red-500" : ""}
              />
            </FormControl>
            {errors.lastName && <FormMessage>{errors.lastName}</FormMessage>}
          </FormItem>
        </div>
      </div>
      
      <div>
        <FormItem>
          <FormLabel htmlFor="email">Email*</FormLabel>
          <FormControl>
            <Input
              id="email"
              type="email"
              placeholder="john.doe@example.com"
              value={email}
              onChange={(e) => setFormField('email', e.target.value)}
              className={errors.email ? "border-red-500" : ""}
            />
          </FormControl>
          {errors.email && <FormMessage>{errors.email}</FormMessage>}
        </FormItem>
      </div>
      
      <div>
        <FormItem>
          <FormLabel htmlFor="phone">Phone Number</FormLabel>
          <FormControl>
            <Input
              id="phone"
              placeholder="(123) 456-7890"
              value={phone}
              onChange={(e) => setFormField('phone', e.target.value)}
              className={errors.phone ? "border-red-500" : ""}
            />
          </FormControl>
          {errors.phone && <FormMessage>{errors.phone}</FormMessage>}
        </FormItem>
      </div>
    </>
  );
};

export default UserInfoFields;
